import React from 'react';
import styles from './PostStepsIndicator.module.scss';

const PostStepsIndicator = ({ currentStep, totalSteps }) => {
  const steps = [];
  const values = {
    1: '0',
    2: totalSteps === 3 ? '50' : '33.3',
    3: totalSteps === 3 ? '100' : '66.6',
    4: '100',
  };

  const messages = [
    'What do you need',
    'Project details',
    'Your details',
    'Contact freelancers',
  ];

  if (totalSteps === 3) {
    messages.splice(2, 1);
  }

  for (let idx = 1; idx <= messages.length; idx++) {
    steps.push(
      <div
        className={`${styles.step} ${idx <= currentStep ? styles.done : ''}`}
        key={idx}
      >
        {idx} <span className={styles.stepHeading}>{messages[idx - 1]}</span>
      </div>
    );
  }

  return (
    <div
      className={`${styles.wrapper} ${
        totalSteps === 3 ? styles.threeSteps : styles.fourSteps
      }`}
    >
      {steps.map((step) => step)}
      <div className={`${styles.slider}`} />
      <div
        className={`${styles.sliderProgress}`}
        style={{ width: `calc(${values[currentStep]}% - 25px + 10px)` }}
      />
    </div>
  );
};

export default PostStepsIndicator;
